/* Purpose: These are global variables that are needed throughout the app.
 * Possible Exports: GlobalVar
 * Author: R. Markowitz (April 2025)
 * Dev Notes: 
*/


const originURL = window.location.origin
const portalURL = originURL + "/Portal"

const GlobalVar = {
    "USER_POOL_ID":"us-east-1_t3mDccYCD",
    "IDENTITY_POOL_ID":"us-east-1:2d853735-f2f5-478a-a57b-8b8e99f21a15", 
    "APP_CLIENT_ID":"309cjh9al5589d73kvfshbbl0f", 
    "COGNITO_DOMAIN":"https://us-east-1t3mdccycd.auth.us-east-1.amazoncognito.com", 
    "AUTHORITY":"https://cognito-idp.us-east-1.amazonaws.com/us-east-1_t3mDccYCD", 
    "REGION":"us-east-1", 
    "HOME_URL":originURL, 
    "PORTAL_URL":portalURL
}


export default GlobalVar;
